import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import ResetPassword from "./pages/PasswordReset";
import AccountApproved from "./pages/AccountApproved";
// import Welcome from "./pages/Welcome";
// import Dashboard from "./pages/Dashboard";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/SignUp">
          <SignUp />
        </Route>
        <Route path="/SignIn">
          <SignIn />
        </Route>
        <Route path="/ResetPassword/:userId">
          <ResetPassword />
        </Route>
        <Route path="/AccountApproved/:emailId">
          <AccountApproved />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
